import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, delay, map, mergeMap, tap } from 'rxjs/operators';
import { concat, of } from 'rxjs';
import { CostCentersError, CostCentersLoaded, CostCentersLoading, CostCentersRequested } from './costCenters.actions';
import { CostCentersService } from '../../@core/data/cost-centers/cost-centers.service';

@Injectable()
export class CostCentersEffects {
  constructor(private actions$: Actions, private costCentersService: CostCentersService) {}

  requestCostCenters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CostCentersRequested),
      mergeMap(() =>
        concat(
          of(CostCentersLoading()),
          this.costCentersService.getCostCenters().pipe(
            map((res: any) => {
              if (res?.status) {
                return CostCentersLoaded({ costCenters: res?.data || [] });
              }
              return CostCentersError();
            }),
            catchError(() => of(CostCentersError()))
          )
        )
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CostCentersError),
        tap(() => {})
      ),
    { dispatch: false }
  );
}
